import { UserAPI } from 'src/api'

export default {
  namespaced: true,
  state: {
    currentUser: {},
    loading: false,
  },
  mutations: {
    SET_USER(state, userData) {
      state.currentUser = userData
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },
  actions: {
    async GET({ commit }) {
      commit('SET_LOADING', true)

      try {
        const data = await UserAPI.getCurrent()
        commit('SET_USER', data)
      } finally {
        commit('SET_LOADING', false)
      }
    },
    CLEAR({ commit }) {
      commit('SET_USER', {})
    },
  },
}
